//引荐计划相关接口
import request from "../api/request";
import utils from "../../utils/index";
import pfile from "@/utils/secretkey/pfile";
import sfile from "@/utils/secretkey/sfile";
var ak = utils.genak();
var ed = utils.re(ak, unescape(pfile)); //秘钥
function decrypt(data) {
    if (data?.ak) {
        let plaintext = utils.rd(data.ak, unescape(sfile));
        let obj = utils.secret(data.ed, plaintext, true);
        return JSON.parse(obj);
    } else {
        return data;
    }
}
function inParameter(data) {
    if (data) {
        return { sn: ed, jt: utils.secret(data, ak) };
    } else {
        return data;
    }
}
//扩充下线模式图表数据
export function exPandModeAPI(data) {
  return request({
      url: "/referralProgram/creditDataExpandOfflineMode",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
//引荐计划首页
export function exPandIndexAPI(data) {
  return request({
      url: "/referralProgram/index",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
//修改奖励方式
export function exPandCheckAPI(data) {
  return request({
      url: "/referralProgram/modifyGrantType",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
//邀请记录
export function exPandListAPI(data) {
  return request({
      url: "/referralProgram/invitedList",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
//收益记录接口 (是以前下线返利的，后端说可以用老接口)
export function inviteNumPeopleAPI(data) {
  return request({
      url: "/cash/inviteNumPeople",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
//获取规则接口
export function getRule(data) {
  return request({
      url: "/referralProgram/ruleInfo",
      method: "post",
      data: inParameter(data),
  })
      .then((res) => {
          res.data = decrypt(res.data);
          return res;
      })
      .catch((err) => {
          console.log(err);
      });
}
